import { LogLevel } from "@azure/msal-browser";
import properties from "./environmentProperties";
const envConfig = properties.currentEnvironment;
export const msalConfig = {
    auth: {
        clientId: envConfig.adClientId,
        authority: "https://login.microsoftonline.com/" + envConfig.adTenantId,
        redirectUri: envConfig.redirectUrl
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};


export const loginRequest = {
    scopes: ["User.Read"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    signoutEndpoint: "https://login.microsoftonline.com/common/oauth2/v2.0/logout"
};
